/**
 * H25 ทำเนียบยุทธภพ: weekly fame boards. Data only; `systems/fameBoards.ts` scores and settles them.
 * Boards: neigong (total levels), arts (move mastery), duel wins, and each profession's output, all this week.
 * Rank 1 wears a title (ฉายา) and a placeholder outfit for the week; ranks 2-3 get gold. Everything resets at the
 * real-week boundary (Monday 05:00 Thai time, dayReset.ts `realWeek`).
 */
import { PROFESSION_LIST } from './professions';
import type { SkinDef } from './skins';

export interface FameBoardDef {
  readonly id: string;
  readonly name: string;
  readonly unit: string;
  /** NPC wanderer score range for a week. */
  readonly npc: readonly [number, number];
  /** Rank 1's title (ฉายา) and outfit name. */
  readonly title: string;
  readonly outfit: string;
  readonly color: string;
}

const boards: FameBoardDef[] = [
  { id: 'neigong', name: 'กำลังภายใน', unit: 'ระดับรวม', npc: [8, 60], title: 'ปราณลึกหนึ่งยุทธภพ', outfit: 'ชุดปราณลึก', color: '90,170,255' },
  { id: 'arts', name: 'วิชาและกระบวนท่า', unit: 'ความชำนาญ', npc: [10, 90], title: 'ท่าวิชาเลื่องลือ', outfit: 'ชุดเจ้าตำรา', color: '224,170,58' },
  { id: 'duel', name: 'ชนะประลอง', unit: 'ชัยชนะ', npc: [0, 14], title: 'ผู้พิชิตลานประลอง', outfit: 'ชุดผู้พิชิตลาน', color: '220,60,70' },
];
const PROF_COLOR = ['150,110,60', '120,130,140', '70,150,200', '90,170,90', '200,190,80', '200,100,50', '170,90,170', '220,140,90'];
PROFESSION_LIST.forEach((p, i) =>
  boards.push({
    id: `prof:${p.id}`,
    name: `อาชีพ${p.name}`,
    unit: 'ผลงานสัปดาห์นี้',
    npc: [4, 70],
    title: `เลิศฝีมือ${p.name}`,
    outfit: `ชุด${p.name}ยอดฝีมือ`,
    color: PROF_COLOR[i % PROF_COLOR.length]!,
  }),
);
export const FAME_BOARDS: readonly FameBoardDef[] = boards;
export const FAME_BOARD: Readonly<Record<string, FameBoardDef>> = Object.fromEntries(boards.map((b) => [b.id, b]));

export const FAME = {
  /** Rows shown per board. */
  top: 10,
  /** NPC wanderers filling each board. */
  npcCount: 24,
  /** Gold for ranks 2 and 3 at reset. */
  gold: { 2: 300, 3: 150 } as Readonly<Record<number, number>>,
  skinPrefix: 'fame-',
  titlePrefix: 'fame:',
} as const;

/** Placeholder weekly outfits, one per board (appended to the skin list). */
export const FAME_SKINS: readonly SkinDef[] = boards.map((b) => ({
  id: `${FAME.skinPrefix}${b.id}`,
  name: b.outfit,
  slot: 'outfit' as const,
  desc: `ชุดประจำสัปดาห์ของอันดับ 1 ทำเนียบ${b.name} หมดอายุเมื่อขึ้นสัปดาห์ใหม่`,
  color: b.color,
}));
